import { FC, memo } from 'react';
import {
	Grid, Stepper, Step, StepLabel, Typography, Box,
} from '@mui/material';
import { Logo } from '../../../../components';
import { StyledStepConnector, StyledStepIcon } from '../../../App/components/Nav/components';

interface Props {
	currentStep: number;
}

export const IPCNav: FC<Props> = memo(({ currentStep }) => {
	const stepLabels = ['Create User', 'Pharmacy Registration'];

	return (
		<Box
			sx={{
				width: '100%',
				padding: 2,
				marginBottom: 2,
				background: 'linear-gradient(95deg, #1A6AE1 0%, #158DEB 50%, #257CFF 100%)',
			}}
		>
			<Grid container justifyContent='space-evenly' alignItems='center'>
				<Grid
					item
					xs={2}
					container
					direction='column'
				>
					<Logo />
					<Grid sx={{ mt: 2 }} item container direction='column' justifyContent='center' alignItems='center'>
						<a href='tel:+18009585540' rel='noreferrer'>
							<Typography 
								variant='caption' 
								sx={{
									color: '#fff',
									textDecoration: 'none',
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								1 (800) 958-5540
							</Typography>
						</a>
						<a href='mailto:support@pharmacymarketplace.com' target='_top' rel='noreferrer'>
							<Typography 
								variant='caption' 
								sx={{
									color: '#fff',
									textDecoration: 'none',
									'&:hover': {
										textDecoration: 'underline',
									},
								}}
							>
								support@pharmacymarketplace.com
							</Typography>
						</a>
					</Grid>
				</Grid>
				<Grid item xs={10}>
					<Stepper
						alternativeLabel
						activeStep={currentStep - 1}
						connector={<StyledStepConnector />}
						sx={{
							'& .MuiStepLabel-label': {
								color: '#fff',
							},
							'& .MuiStepLabel-label.Mui-completed': {
								color: '#fff',
							},
						}}
					>
						{stepLabels.map((label) => (
							<Step key={label}>
								<StepLabel StepIconComponent={StyledStepIcon}>
									{label}
								</StepLabel>
							</Step>
						))}
					</Stepper>
				</Grid>
			</Grid>
		</Box>
	);
}); 